import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { scaledPreviewDimensions } from './previewCanvasConstants';

export interface PreviewCanvasFrameProps {
  width: number;
  pageCount?: number;
  className?: string;
  children: ReactNode;
}

/**
 * Shared A4 sizing contract for live artboard iframes and frozen JPG
 * previews so users cannot tell which mode they are in from layout alone.
 */
export function PreviewCanvasFrame({
  width,
  pageCount = 1,
  className,
  children,
}: PreviewCanvasFrameProps) {
  const { width: scaledWidth, height: scaledHeight } = scaledPreviewDimensions(
    width,
    pageCount,
  );

  return (
    <div
      className={cn('relative overflow-hidden bg-white', className)}
      style={{ width: scaledWidth, height: scaledHeight }}
    >
      {children}
    </div>
  );
}
